<script>
    import { format, subMinutes, isBefore } from 'date-fns';
    import time from '../state/time';
    import modals from '../state/modals';
    import user from '../state/user';
    import API from '../api';

    // Event shorthand
    let event = null;
    $: event = $modals.event_item;

    let onlineCode = '';
    let onlineCodeInvalid = false;
    let onlineCodeProcessing = false;

    async function onlineCodeProcess()
    {
        onlineCodeInvalid = false;
        onlineCodeProcessing = true;
        let resp = await API.goToStream(event.evr_id, onlineCode);

        // Got invalid code
        if (!resp) {
            onlineCodeProcessing = false;
            onlineCodeInvalid = true;
            return;
        }

        // Redirect to stream
        location.href = resp.url;
    }

    // Just close the modal
    function closeModal(e) {
        modals.toggleEventModal();
    }

    // Format specified date
    function formatDate(date) {
        return format(date, 'D. M. YYYY');
    }

    function formatTime(date) {
        return format(date, 'H:mm');
    }

    function onReserveClick() {
        modals.toggleReservationModal(true, false);
    }

    function onReserveWithCreditClick() {
        modals.toggleReservationModal(true, true);
    }

    function onLoginClick() {
        modals.toggleEventModal();
        modals.toggleSignModal(true);
    }

    function onBuyCreditsClick() {
        modals.toggleEventModal();
        modals.toggleCreditsModal(true);
    }

    function getMaxReserveTime(event) {
        let mins = 90; // 1.5 hours

        // Got minimum defined and already surpassed it
        if (event.evn_min && event.evn_min <= event.reserved) {
            mins = 30;
        }

        return subMinutes(event.evr_from, mins);
    }

    function getMaxCancelTime(event) {
        // TODO: Replace with db value
        return subMinutes(event.evr_from, 60 * 3); // 3 hours
    }

    function canReserve(event, now) {
        let maxTime = getMaxReserveTime(event);
        let maxCapacity = event.evn_max;
        let reserved = event.reserved;

        if (event.evr_canceled > 0) return false;

        return isBefore(now, maxTime) && (!maxCapacity || maxCapacity > reserved);
    }

    function canCancel(event, now) {
        let maxTime = getMaxCancelTime(event);
        return isBefore(now, maxTime);
    }

    function canUseCredit(event) {
        if (!$user) return false;
        if ($user.credits < 1) return false;

        // TODO: Check for event type
        return true;
    }

    function lessonsText(count) {
        if (count >= 1 && count <= 4) {
            return `${count} lekce`;
        }

        return `${count} lekcí`;
    }
</script>

<style>
    .modal-card-body {
        border-radius: 0 0 8px 8px;
    }

    .group {
        display: inline-flex;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 10px 10px 0;
    }

    .group + .notification {
        margin-bottom: 10px;
    }

    .group .caption, .group .text {
        padding: 2px 8px;
    }

    .group .caption {
        font-weight: 500;
        background: #e4e4e4;
    }

    .group .text {
        background: #ececec;
        /* flex: 1; */
    }

    hr {
        margin: 10px 0 20px;
    }

    .reserve .has-reserved {
        text-align: center;
    }

    .reserve .has-reserved .button {
        margin-top: 10px;
    }

    .level .level-right, .level .level-left {
        width: 50%;
        flex-direction: column;
    }

    .points-login, .points-logged {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .points-login .button {
        margin-top: 10px;
    }

    .stream-access {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

{#if $modals.event_opened && !$modals.reservation_opened}
    <div class="modal is-active">
        <div class="modal-background" on:click={closeModal}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <div class="modal-card-title">{event.evn_title}</div>
                <button class="delete" aria-label="Zavřít" on:click={closeModal}></button>
            </header>
            <section class="modal-card-body">
                {#if event.evr_original_from}
                    <div class="notification is-info">
                        Lekce byla přesunuta z původního času {format(event.evr_original_from, 'H:mm')}.
                    </div>
                {/if}

                <div>
                    <div class="group">
                        <span class="caption">Datum lekce</span>
                        <span class="text">{formatDate(event.evr_from)}</span>
                    </div>
                    <div class="group">
                        <span class="caption">Délka lekce</span>
                        <span class="text">{event.length} minut</span>
                    </div>
                </div>

                <div>
                    <div class="group">
                        <span class="caption">Začátek lekce</span>
                        <span class="text">{formatTime(event.evr_from)}</span>
                    </div>
                    <div class="group">
                        <span class="caption">Konec lekce</span>
                        <span class="text">{formatTime(event.evr_to)}</span>
                    </div>
                </div>

                <hr>

                <div>
                    {#if event.evn_max}
                        <div class="group">
                            <span class="caption">Kapacita</span>
                            <span class="text">{event.evn_max} míst</span>
                        </div>

                        <div class="group">
                            <span class="caption">Volná místa</span>
                            <span class="text">{event.evn_max - event.reserved}</span>
                        </div>
                    {:else}
                        <div class="group">
                            <span class="caption">Obsazená místa</span>
                            <span class="text">{event.reserved}</span>
                        </div>
                    {/if}
                </div>

                {#if event.evn_min}
                    <div>
                        <div class="group">
                            <span class="caption">Minimální počet účastníků</span>
                            <span class="text">{event.evn_min}</span>
                        </div>
                    </div>
                {/if}

                {#if event.ven_id}
                    <hr>

                    <div>
                        <div class="group">
                            <span class="caption">Místo konání</span>
                            <span class="text">{event.ven_caption}</span>
                        </div>

                        <div class="group">
                            <span class="caption">Adresa</span>
                            <span class="text">{event.ven_address}</span>
                        </div>

                        {#if event.ven_notice}
                            <div class="notification is-warning"><strong>Upozornění:</strong> {event.ven_notice}</div>
                        {/if}
                    </div>
                {/if}

                {#if canReserve(event, $time.now) && event.evr_canceled < 1}
                    <div class="notification is-info">
                        Rezervace je možná do {format(getMaxReserveTime(event), 'D. M. YYYY H:mm')}.
                    </div>
                {/if}

                <hr>

                {#if event.evt_id == 2}
                    <div class="stream-access">
                        {#if !event.res_id}
                            <p>Pokud máte kód pro přístup k vysílání, zadejte ho zde:</p>
                            <div class="field has-addons">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" placeholder="Kód" bind:value={onlineCode}>
                                    <span class="icon is-small is-left">
                                        <i class="fas fa-lock"></i>
                                    </span>
                                </div>
                                <div class="control">
                                    <button class="button is-info" on:click={onlineCodeProcess} disabled={onlineCodeProcessing || !onlineCode.length}>Přejít k vysílání</button>
                                </div>
                            </div>

                            {#if onlineCodeInvalid}
                                <div class="notification is-danger">
                                    Zadali jste neplatný kód!
                                </div>
                            {/if}
                        {:else}
                            <button class="button is-info" on:click={onlineCodeProcess} disabled={onlineCodeProcessing}>Přejít k vysílání</button>
                        {/if}
                    </div>
                    <hr>
                {/if}

                <div class="reserve">
                    {#if event.res_id}
                        <p class="has-reserved">
                            <strong>Na tuto lekci již máte místo rezervováno!</strong><br>
                            <br>

                            <!-- Check if the user can cancel the reservation -->
                            {#if canCancel(event, $time.now)}
                                <div class="notification is-warning">
                                    Rezervaci je možné zrušit do {format(getMaxCancelTime(event), 'D. M. YYYY H:mm')}.
                                </div>

                                <a href="/zrusit/{event.res_id}/{event.res_code}" class="button is-danger">Zrušit rezervaci</a>
                            {:else}
                                <div class="notification is-info">Tuto rezervaci již nelze zrušit!</div>
                            {/if}
                        </p>
                    {:else if event.evr_canceled > 0}
                        <div class="notification is-danger">Tato lekce byla zrušena!</div>
                    {:else if !canReserve(event, $time.now)}
                        <div class="notification is-danger">Tuto lekci již nelze rezervovat!</div>
                    {:else}
                        <div class="level">
                            <div class="level-left">
                                {#if $user && $user.credits > 0}
                                    <article class="message">
                                        <div class="message-body">
                                            Máte k dispozici kredity, které můžete využít k platbě rezervace!<br>
                                            <br>
                                            Pro rezervaci použijte tlačítko vpravo.
                                        </div>
                                    </article>
                                {:else}
                                    <div class="group">
                                        <span class="caption">Cena jednorázové lekce</span>
                                        <span class="text">{event.evt_price} Kč</span>
                                    </div>

                                    <div class="buttons">
                                        <button class="button is-info" on:click={onReserveClick}>Rezervovat</button>
                                    </div>
                                {/if}
                            </div>

                            <div class="level-right">
                                {#if $user}
                                    <div class="points-logged">
                                        {#if $user.credits > 0}
                                            <div class="group">
                                                <span class="caption">Zbývající kredit</span>
                                                <span class="text">{lessonsText($user.credits)}</span>
                                            </div>

                                            <button class="button is-warning" on:click={onReserveWithCreditClick}>Rezervovat pomocí kreditu</button>
                                        {:else}
                                            <p class="has-text-centered">
                                                Nemáte žádný kredit.
                                            </p>

                                            <button class="button is-warning" on:click={onBuyCreditsClick}>Dobít</button>
                                        {/if}
                                    </div>
                                {:else}
                                    <div class="points-login">
                                        Chcete využít své kredity ? Přihlašte se

                                        <button class="button is-primary" on:click={onLoginClick}>Přihlásit se</button>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    {/if}
                </div>
            </section>
        </div>
    </div>
{/if}